import { ref } from 'vue'

window.dataLayer = window.dataLayer || []

let ecommerce = ref({})

export function useGtm() {

    function trackEvent(data, event) {
        // console.log('trackEvent', data, event)
        switch ( event ) {
            case 'addToCart': prepareData(data, 'add_to_cart'); break;
            case 'addToWishlist': prepareData(data, 'add_to_wishlist'); break;
            case 'removeFromCart': prepareData(data, 'remove_from_cart'); break;
            case 'viewItem': prepareData(data, 'view_item'); break;
            case 'viewItemList': prepareData(data, 'view_item_list'); break;
            case 'viewCart': prepareData(data, 'view_cart'); break;
            case 'beginCheckout': prepareData(data, 'begin_checkout'); break;
            case 'purchase': prepareData(data, 'purchase'); break;
            case 'addPaymentInfo': prepareData(data, 'add_payment_info'); break;
            case 'addShippingInfo': prepareData(data, 'add_shipping_info'); break;
        }
    }

    const prepareData = (data, eventName) => {
        // console.log('preparing data', data, eventName)

        ecommerce.value = data

        pushDataLayer(eventName)
    }

    const pushDataLayer = (eventName) => {
        // console.log('pushing to data layer:', eventName, ecommerce.value)

        window.dataLayer.push({ ecommerce: null })
        window.dataLayer.push({
            event: eventName,
            ecommerce: ecommerce.value
        })
    }

    return {
        trackEvent
    }
}
